var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.error === 'ERROR_AUTH')?_c('p',{staticStyle:{"text-align":"center"}},[_c('strong',[_vm._v("Error:")]),_vm._v(" Unable to login. ")]):(_vm.error === 'ERROR_UNKNOWN_PARAM')?_c('p',{staticStyle:{"text-align":"center"}},[_c('strong',[_vm._v("Error:")]),_vm._v(" Unknown params. ")]):_c('ui-loading')
}
var staticRenderFns = []

export { render, staticRenderFns }